import axios from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, {
  retries: Number.MAX_SAFE_INTEGER,
  retryDelay: (retryNumber, error) => {
    if (retryNumber === 1) {
      return (
        (retryNumber * Math.random() * (retryNumber * 4) + retryNumber) * 1000
      )
    } else if (retryNumber === 2) {
      return 4000
    } else if (retryNumber === 3) {
      return 8000
    } else if (retryNumber === 4) {
      return 16000
    } else {
      return 30000
    }
  },
  retryCondition: e =>
    e.message === 'Network Error' ||
    e.response.status === 503 ||
    e.response.status === 502
})

export { arrayToQuery, embedsToQuery, getHeaders } from './helpers'
export * from './timeline'
export * from './customFields'
export * from './media'
export * from './notifications'
export * from './tags'
export * from './events'
export * from './accounts'
export * from './auth'
export * from './environments'
export * from './config'
export * from './stacks'
export * from './avatars'
export * from './integrations'
export * from './timezones'
export * from './billing'
export * from './articles'
export * from './externals'
export * from './inboxes'
export * from './views'
export * from './users'
export * from './sessions'
export * from './roles'
export * from './tasks'
export * from './teams'
export * from './activities'
export * from './widget'
export * from './reminders'
